// Copyright (C) 2020 TANNER AG

import React from "react";

const TcoFrame = () => (
    <iframe
        className="tco-root"
        title="TCO"
        src={`${process.env.PUBLIC_URL}/243b880003fcc42b8f8783d91ba13f65/index.html`}
        style={{ height: "calc(100vh - 75px)" }}
    >
        <p>TCO not available</p>
    </iframe>
);

export default TcoFrame;



// WEBPACK FOOTER //
// ./src/tco/tcoframe.js